import LayoutGrid from "@mui/material/Unstable_Grid2";
import { Box, Button, ButtonGroup } from "@mui/material";

import { Form } from "devextreme-react";
import { GroupItem, ISimpleItemProps, SimpleItem } from "devextreme-react/form";

import { PageProps } from "@ezhou/core";

import { DataFormFieldDataChangeEvent, DataFormProps, FormItemConfig } from "./dataFormModel";
import DevExtremeDataFormNoEditableFieldTemplate from "./DevExtremeDataFormNoEditableFieldTemplate";

export const DevExtremeDataForm = (props: DataFormProps) => {
  const data = props.formData;
  const model = props.formModel;
  let groupColCount = 2;
  let itemColCount = 2;
  if (model.panels.length == 1) {
    groupColCount = 1;
    itemColCount = 3;
  }
  if (props.groupColCount) {
    groupColCount = props.groupColCount;
  }
  if (props.itemColCount) {
    itemColCount = props.itemColCount;
  }

  const onSaveClick = () => {
    if (props.onSaveClick) {
      props.onSaveClick(data);
      return;
    } else {
      console.log("Saving form data");
      console.log(data);
    }
  };

  const onFieldDataChanged = (e: DataFormFieldDataChangeEvent) => {
    if (props.onFieldDataChanged) {
      props.onFieldDataChanged(e);
    }
  };

  return (
    <>
      <Form formData={data} colCount={groupColCount} onFieldDataChanged={onFieldDataChanged}>
        {model.panels.map((group) => (
          <GroupItem key={group.caption} colCount={itemColCount} caption={group.caption}>
            {group.columns.map((column) => {
              if (column.editorOptions?.disabled) {
                const theData = data ? getDataField(data, column.dataField) : "";
                const theReander = DevExtremeDataFormNoEditableFieldTemplate(
                  theData,
                  column.reasonForNotEditable,
                );
                const deColumn = getDevExtremeColumnItemConfig(props.pageProps, column);
                return (
                  <SimpleItem key={column.dataField} {...deColumn} render={theReander}></SimpleItem>
                );
              } else {
                return renderItemEditor(props.pageProps, column);
              }
            })}
          </GroupItem>
        ))}
      </Form>
      <LayoutGrid container direction={{ xs: "column", md: "row" }}>
        <LayoutGrid xs={12} md={10}></LayoutGrid>
        <LayoutGrid
          xs={12}
          md={2}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "flex-start", md: "flex-end" },
          }}
        >
          <Box>
            <ButtonGroup variant="contained">
              {props.formData && props.formData.editable && (
                <Button onClick={onSaveClick}>Save</Button>
              )}
              {props.formData && props.formData.editable && props.onDeleteClick && (
                <Button
                  color="error"
                  onClick={() => {
                    props.onDeleteClick!(data);
                  }}
                >
                  Delete
                </Button>
              )}
              {props.formData && props.formData.editable && props.onCancelClick && (
                <Button
                  color="warning"
                  onClick={() => {
                    props.onCancelClick!(data);
                  }}
                >
                  Cancel
                </Button>
              )}
              {props.customActionButtons &&
                props.customActionButtons.map((b, index) => (
                  <Button onClick={() => b.onClick(data)} key={index}>
                    {b.caption}
                  </Button>
                ))}
            </ButtonGroup>
          </Box>
        </LayoutGrid>
      </LayoutGrid>
    </>
  );
};

const getDataField = (data: any, key: string) => {
  const fields = key.split(".");
  let ret: any = data;
  fields.forEach((f) => {
    if (ret === null || ret === undefined) return;
    ret = ret[f];
    if (ret === null || ret === undefined) return;
  });
  return ret;
};

const getDevExtremeColumnItemConfig = (pageProps: PageProps, column: FormItemConfig) => {
  let { label, ...deColumn } = { ...column };
  if (label) {
    (deColumn as ISimpleItemProps).label = { text: pageProps.appUtil.getLocaleString(label) };
  }
  return deColumn;
};

const renderItemEditor = (pageProps: PageProps, column: FormItemConfig) => {
  const deColumn = getDevExtremeColumnItemConfig(pageProps, column);
  return <SimpleItem key={column.dataField} {...deColumn} />;
};
